import type { GoldSetQueueItem } from '../model'

export function getFirstTodo(items: GoldSetQueueItem[]) {
  return items.find((item) => item.status === 'todo')
}

/** The next to-do after `currentKey` in working order, wrapping around; never `currentKey`. */
export function getNextTodo(items: GoldSetQueueItem[], currentKey: string) {
  const index = items.findIndex((item) => item.short_key === currentKey)

  for (let step = 1; step <= items.length; step++) {
    const item = items[(index + step) % items.length]
    if (item.short_key !== currentKey && item.status === 'todo') {
      return item
    }
  }

  return undefined
}

export function getPreviousItem(items: GoldSetQueueItem[], currentKey: string) {
  const index = items.findIndex((item) => item.short_key === currentKey)

  return index > 0 ? items[index - 1] : undefined
}
